import { AlertPlayground } from "../AlertPlayground";
import { BetaTagPlayground } from "../BetaTagPlayground";
import { EmptyStatesPlayground } from "../EmptyStatesPlayground";
import { HealthIndicatorPlayground } from "../HealthIndicatorPlayground";
import { LiveDotPlayground } from "../LiveDotPlayground";
import { ProgressBarsPlayground } from "../ProgressBarsPlayground";
import { SegmentBarPlayground } from "../SegmentBarPlayground";
import { StatusIndicatorPlayground } from "../StatusIndicatorPlayground";
import { TagOverflowPlayground } from "../TagOverflowPlayground";
import { TagPlayground } from "../TagPlayground";
import { ToastPlayground } from "../ToastPlayground";
import type { PlaygroundComponentEntry } from "../playgroundComponents";

export const feedbackEntries: PlaygroundComponentEntry[] = [
    {
        id: "alert",
        label: "Alert",
        description: "Inline alert with severity variants.",
        group: "components",
        render: () => <AlertPlayground />,
    },
    {
        id: "beta-tag",
        label: "Beta tag",
        description: "Small beta marker for feature labels.",
        group: "components",
        render: () => <BetaTagPlayground />,
    },
    {
        id: "progress-bars",
        label: "Progress bars",
        description: "Determinate progress indicators.",
        group: "components",
        render: () => <ProgressBarsPlayground />,
    },
    {
        id: "segment-bar",
        label: "Segment bar",
        description: "Proportional multi-segment bar.",
        group: "components",
        render: () => <SegmentBarPlayground />,
    },
    {
        id: "empty-states",
        label: "Empty states",
        description: "Empty state placeholders for pages, panels, and values.",
        group: "components",
        render: () => <EmptyStatesPlayground />,
    },
    {
        id: "tag",
        label: "Tag",
        description:
            "Figma tag with t-shirt sizes, semantic colors, outline, numeric, and a built-in remove action.",
        group: "ready-components",
        render: () => <TagPlayground />,
    },
    {
        id: "tag-overflow",
        label: "Tag overflow",
        description:
            "Tags capped at a max, then a +N tag that opens a popover with the rest; safe inside a board card.",
        group: "components",
        render: () => <TagOverflowPlayground />,
    },
    {
        id: "live-dot",
        label: "Live dot",
        description:
            "Pulsing dot for something happening now, in two sizes and neutral or accent tones.",
        group: "components",
        render: () => <LiveDotPlayground />,
    },
    {
        id: "status-indicator",
        label: "Status indicator",
        description: "Colored status dot with label.",
        group: "components",
        render: () => <StatusIndicatorPlayground />,
    },
    {
        id: "health-indicator",
        label: "Health indicator",
        description:
            "Engagement health chip: On track, Watching, At risk, with a dot in the tone.",
        group: "components",
        render: () => <HealthIndicatorPlayground />,
    },
    {
        id: "toast",
        label: "Toast",
        description:
            "Toast notifications with default, success, error, warning, and info types.",
        group: "components",
        render: () => <ToastPlayground />,
    },
];
